import { Fragment, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import FormTitle from "layouts/views/components/FormTitle";

import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getWarehouseOptions } from "services/data.internal.service";
import { getCurrencyCode } from "services/data.internal.service";
import { useCustWhOptionsQuery } from "hooks/useQueryHook";
import { useUOMOptionsQuery } from "hooks/useUOMQuery";
import { TitleField, Text, SelectField } from "ui-components/Form";
import { SwitchField } from "ui-components/Form";
import { useZoneOptionsQuery } from "hooks/useZoneQuery";
import { useLocationOptionsQuery } from "hooks/useLocationQuery";

function CustomerWarehouseSetting2({
  values = {},
  formRender,
  control,
  errors,
  setValue,
  mode = "ADD",
}) {
  const { customerCode } = values;
  const palletTypeOpt = [
    { label: "Small Pallet", value: "SMALL" },
    { label: "Standard Pallet", value: "STANDARD" },
    { label: "Large Pallet", value: "LARGE" },
  ];
  const [currencyCodeOpt, setCurrencyCodeOpt] = useState([]);

  // ------------------ Options ------------------
  // Default Receiving
  const [defRecvZoneOpt, setDefRecvZoneOpt] = useState([]);
  const [defRecvLocationOpt, setDefRecvLocationOpt] = useState([]);
  // Trade Return Putaway

  const [defTRPutawayZoneOpt, setDefTRPutawayZoneOpt] = useState([]);
  const [defTRPutawayLocationOpt, setDefTRPutawayLocationOpt] = useState([]);
  // Putaway

  const [defPutawayZoneOpt, setDefPutawayZoneOpt] = useState([]);
  const [defPutawayLocationOpt, setDefPutawayLocationOpt] = useState([]);
  // Shipping

  const [defShipZoneOpt, setDefShipZoneOpt] = useState([]);
  const [defShipLocationOpt, setDefShipLocationOpt] = useState([]);

  const [warehouseOption, setWarehouseOption] = useState([]);
  const [warehousesOpt, setWarehousesOpt] = useState([]);

  const [uomOpt, setUOMOpt] = useState([]);

  //const
  useQuery(["currency-options"], () => getCurrencyCode(), {
    onSuccess: (data) => setCurrencyCodeOpt(data.data.data),
  });

  useQuery(["warehouse-options"], () => getWarehouseOptions(), {
    onSuccess: (data) => setWarehouseOption(data.data.data),
  });

  useCustWhOptionsQuery({
    customerCode: values.customerCode,
    enabled: values.customerCode !== null && mode === "EDIT",
    onSuccess: (data) => {
      if (data.data.message === "") {
        const options = data.data.data;
        setWarehousesOpt(options);
        setValue("warehouses", options);
      }
    },
  });

  useUOMOptionsQuery({
    onSuccess: (data) => {
      const filter = data.data.data.filter((x) => x.uomType === "Unit");
      setUOMOpt(filter.map((x) => x.uomid));
    },
  });

  useZoneOptionsQuery({
    queryKey: "zone-options-defRecvWh",
    whCode: values.defRecvWh,
    zoneType: "staging",
    onSuccess: (data) => setDefRecvZoneOpt(data.data.data),
  });
  useZoneOptionsQuery({
    queryKey: "zone-options-defPutawayWh",
    whCode: values.defPutawayWh,
    zoneType: "storage",
    onSuccess: (data) => setDefPutawayZoneOpt(data.data.data)
  });
  useZoneOptionsQuery({
    queryKey: "zone-options-defTRPutawayWh",
    whCode: values.defTRPutawayWh,
    zoneType: "return",
    onSuccess: (data) => setDefTRPutawayZoneOpt(data.data.data)
  });
  useZoneOptionsQuery({
    queryKey: "zone-options-defShipWh",
    whCode: values.defShipWh,
    zoneType: "shipping",
    onSuccess: (data) => setDefShipZoneOpt(data.data.data),
  });
  useLocationOptionsQuery({
    queryKey: "location-options-defRecvWh",
    whCode: values.defRecvWh,
    zoneID: values.defRecvZone,
    onSuccess: (data) => setDefRecvLocationOpt(data.data.data),
  });
  useLocationOptionsQuery({
    queryKey: "location-options-defPutawayWh",
    whCode: values.defPutawayWh,
    zoneID: values.defPutawayZone,
    onSuccess: (data) => setDefPutawayLocationOpt(data.data.data),
  });
  useLocationOptionsQuery({
    queryKey: "location-options-defTRPutawayWh",
    whCode: values.defTRPutawayWh,
    zoneID: values.defTRPutawayZone,
    onSuccess: (data) => setDefTRPutawayLocationOpt(data.data.data),
  });
  useLocationOptionsQuery({
    queryKey: "location-options-defShipWh",
    whCode: values.defShipWh,
    zoneID: values.defShipZone,
    onSuccess: (data) => setDefShipLocationOpt(data.data.data),
  });

  const onSelectChange = (name, option) => {
    setValue(name, option);

    switch (name) {
      case "defRecvWh":
        setValue("defRecvZone", null);
        setValue("defRecvLocation", null);
        setDefRecvZoneOpt([]);
        setDefRecvLocationOpt([]);
        break;
      case "defRecvZone":
        setValue("defRecvLocation", null);
        setDefRecvLocationOpt([]);
        break;
      case "defTRPutawayWh":
        setValue("defTRPutawayZone", null);
        setValue("defTRPutawayLocation", null);
        setDefTRPutawayZoneOpt([]);
        setDefTRPutawayLocationOpt([]);
        break;
      case "defTRPutawayZone":
        setValue("defTRPutawayLocation", null);
        setDefTRPutawayLocationOpt([]);
        break;
      case "defPutawayWh":
        setValue("defPutawayZone", null);
        setValue("defPutawayLocation", null);
        setDefPutawayZoneOpt([]);
        setDefPutawayLocationOpt([]);
        break;
      case "defPutawayZone":
        setValue("defPutawayLocation", null);
        setDefPutawayLocationOpt([]);
        break;
      case "defShipWh":
        setValue("defShipZone", null);
        setValue("defShipLocation", null);
        setDefShipZoneOpt([]);
        setDefShipLocationOpt([]);
        break;
      case "defShipZone":
        setValue("defShipLocation", null);
        setDefShipLocationOpt([]);
        break;
    }
  };

  return (
    <MDBox>
      <FormTitle
        title={mode === "EDIT" ? "Edit Customer Warehouse Setting" : "Customer Warehouse Setting"}
      />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { disabled, editable, ...data } = property;
              const xs = 6 / 2;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(disabled && { disabled }),
                ...(mode === "EDIT" && editable === false && { disabled: true, type: "text" }),
              };
              let renderField;
              switch (fieldProps.type) {
                case "text":
                case "number":
                  renderField = <Text field={fieldProps} />;
                  break;
                case "switch":
                  renderField = <SwitchField field={fieldProps} />;
                  break;
                case "select":
                  let options = [];
                  switch (data.name) {
                    case "currencyCode":
                      options = currencyCodeOpt;
                      break;

                    case "defRecvWh":
                    case "defTRPutawayWh":
                    case "defPutawayWh":
                    case "defShipWh":
                      options = warehousesOpt;
                      break;

                    case "defRecvZone":
                      options = defRecvZoneOpt;
                      break;
                    case "defRecvLocation":
                      options = defRecvLocationOpt;
                      break;
                    case "defTRPutawayZone":
                      options = defTRPutawayZoneOpt;
                      break;
                    case "defTRPutawayLocation":
                      options = defTRPutawayLocationOpt;
                      break;
                    case "defPutawayZone":
                      options = defPutawayZoneOpt;
                      break;
                    case "defPutawayLocation":
                      options = defPutawayLocationOpt;
                      break;
                    case "defShipZone":
                      options = defShipZoneOpt;
                      break;
                    case "defShipLocation":
                      options = defShipLocationOpt;
                      break;
                    case "palletType":
                      options = palletTypeOpt;
                      break;
                    case "baseUOM":
                    case "caseUOM":
                    case "palletUOM":
                      options = uomOpt;
                      break;
                  }
                  renderField = (
                    <SelectField
                      field={fieldProps}
                      options={options}
                      onChange={(e, option) => {
                        onSelectChange(data.name, option);
                      }}
                    />
                  );
                  break;
                case "multi-select":
                  renderField = (
                    <SelectField
                      field={{ ...fieldProps, multiple: true }}
                      options={warehouseOption}
                      onChange={(e, option) => {
                        setValue("warehouses", option);
                        setWarehousesOpt(option);
                      }}
                    />
                  );
                  break;
                case "title":
                  renderField = <TitleField label={data.label} />;
                  break;
              }

              return (
                <Grid item xs={xs} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default CustomerWarehouseSetting2;
